<template>
  <router-link :to="'/chats/' + chat._id" :data-chat-id="chat._id" :data="unread_width" class="li">
    <div style="display: flex;align-items: center;" class="list_body-content">
      <div class="project_thumbnail">
        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.0313 0.710938H1.96877C1.69319 0.710938 1.4289 0.82041 1.23404 1.01527C1.03918 1.21013 0.929703 1.47442 0.929703 1.75V13.625C0.928629 13.8231 0.984698 14.0173 1.09119 14.1844C1.19769 14.3514 1.35009 14.4842 1.53013 14.5668C1.66759 14.6306 1.81724 14.6638 1.96877 14.6641C2.21355 14.6642 2.45037 14.5771 2.63673 14.4184L2.64341 14.4125L5.0288 12.3217C5.05552 12.3003 5.08882 12.2887 5.12306 12.2891H15.0313C15.3068 12.2891 15.5711 12.1796 15.766 11.9847C15.9609 11.7899 16.0703 11.5256 16.0703 11.25V1.75C16.0703 1.47442 15.9609 1.21013 15.766 1.01527C15.5711 0.82041 15.3068 0.710938 15.0313 0.710938ZM15.1797 11.25C15.1797 11.2894 15.1641 11.3271 15.1362 11.355C15.1084 11.3828 15.0706 11.3984 15.0313 11.3984H5.12306C4.87861 11.3987 4.6421 11.4852 4.45509 11.6426L4.44841 11.6486L2.06154 13.7393C2.03981 13.7567 2.01363 13.7676 1.98599 13.7709C1.95834 13.7741 1.93035 13.7695 1.90519 13.7576C1.88004 13.7457 1.85875 13.7269 1.84374 13.7035C1.82874 13.68 1.82062 13.6528 1.82033 13.625V1.75C1.82033 1.71063 1.83597 1.67288 1.8638 1.64504C1.89164 1.6172 1.9294 1.60156 1.96877 1.60156H15.0313C15.0706 1.60156 15.1084 1.6172 15.1362 1.64504C15.1641 1.67288 15.1797 1.71063 15.1797 1.75V11.25Z" fill="#0077FF"/>
        </svg>
      </div>
      <div v-if="getUserData.theme" class="project_icon" :style="'background-color: ' + $shiftPaletteHue(chat.color, '#cb4646', getUserData.theme.color)">
        {{ chat.name[0] }}
      </div>
      <div class="project_name_body" :class="chat.last_message.user_id ? '' : 'no_messages'">
        <div v-if="editing" class="project_name">
          <input
            id="renameChatInput"
            v-model="localName"
            type="text"
            @click.prevent="() => true"
            @blur="renameInputBlur"
            @keyup.exact.enter="renameInputBlur"
          />
        </div>
        <div v-else class="project_name">
          {{ chat.name }}
        </div>
      </div>
    </div>
    <div v-if="unread_number(chat._id) > 0" class="unread" style="opacity: 0">
        <p 
          v-if="getChatsMentions[chat._id] && getChatsMentions[chat._id].mentions > 0"
          class="unread__mention"
        >
          @
        </p>
        <p class="unread__count">
          {{ unread_number(chat._id) }}
        </p>
      </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";
import { EventEmitter } from "../../main";

export default {
  props: {
    chat: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    renameLocaly: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      localName: "",
      unread_width: 0,
      last_message: ''
    };
  },
  mounted() {
    this.localName = this.chat.name
    this.last_message_width()
    this.commentParseMentions()
  },
  computed: {
    ...mapGetters([
      "getChatsMentions",
      "getChats",
      "getUserData",
      "getKnownUsers",
      "getRender",
      "getCommentAdd"
    ]),
  },
  methods: {
    last_message_width() {
      if (document.querySelector(`[data-chat-id="${this.chat._id}"] .unread`)) {
        let unread_width = document.querySelector(`[data-chat-id="${this.chat._id}"] .unread`) ? document.querySelector(`[data-chat-id="${this.chat._id}"] .unread`).clientWidth : 0
        document.querySelector(`[data-chat-id="${this.chat._id}"] .project_name_body`).style.width = 150 - unread_width - 3 + 'px'
        document.querySelector(`[data-chat-id="${this.chat._id}"] .unread`).style.opacity = '1'
      }
    },
    project_name_thumbnail(name) {

      if (name) {
        let array_name = name.trim().replaceAll('-', '').split(' ')
        array_name = array_name.filter(e => e != '')
        if (array_name.length >= 2) {
          return String(array_name[0])[0] + '' + String(array_name[1])[0]
        } else {
          return String(array_name[0])[0]
        }
      }

    },
    user_name(user_id) {
      if (user_id) {
        let name = "";
        if (this.getUserData._id == user_id) {
          name = this.$t('app.you');
        } else {
          this.getKnownUsers.forEach((user) => {
            if (user._id == user_id) {
              let first_name = user.name.split(" ");
              name = first_name[0];
            }
          });
        }
        return name;
      }
    },
    unread_number(chat_id) {
      let unread_number = 0;
      this.getChats.forEach((chat, i) => {
        if (chat_id == chat._id) {
          chat.users.forEach((user, user_i) => {
            if (user.user_id == this.getUserData._id) {
              unread_number = user.unread_number;
            }
          });
        }
      });
      return unread_number;
    },
    commentParseMentions() {

      if (this.chat.messages.length > 0) {

        let message = this.chat.messages[this.chat.messages.length - 1].message
        let users = this.chat.users

        const usersByEmail = this.getUsersByEmail(users);
        let mentions = {};
        let messageArr = message.replace(/\n\r?/g, " ").split(" ");
        for (let i = 0; i < messageArr.length; i++) {
          if (messageArr[i] in usersByEmail) {
            mentions[messageArr[i]] = usersByEmail[messageArr[i]];
          }
        }

        message = message.replace(/</g, "&lt;");
        message = message.replace(/>/g, "&gt;");

        for (let email in mentions) {
          message = message.replaceAll(email, mentions[email]);
        }

        this.last_message = message;
      } else {
        this.last_message = '';
      }

    },
    getUsersByEmail(allUsers) {
      let users = {};
      for (let i = 0; i < allUsers.length; i++) {
        if (allUsers[i].user_data) {
          const name = allUsers[i].user_data.name
          const email = allUsers[i].user_data.email
          users["@" + email] = name;
        } else {
          const user = this.getKnownUsers.find(e => e._id == allUsers[i].user_id)
          if (user) {
            const name = user.name
            const email = user.email
            users["@" + email] = name;
          }
        }
      }
      return users;
    },
    saveNewName() {
      const temp = this.localName.trim()
      if (temp.length !== 0 && temp !== this.chat.name) {
        this.$socket.emit("IN_RenameChats", {
          chat_name: temp,
          chat_id: this.chat._id,
        });
        this.renameLocaly(temp)
      } else {
        this.localName = this.chat.name;
      }

    },
    renameInputBlur() {
      if (this.editing) {
        this.saveNewName();
        EventEmitter.$emit("RenameChatFromContext", undefined);
      }
    },
  },
  watch: {
    'chat.name'(name) {
      this.localName = name;
    },
    getRender() {
      setTimeout(() => {
        this.last_message_width()
        this.commentParseMentions()
      }, 1)
    },
    getCommentAdd() {
      setTimeout(() => this.commentParseMentions(), 10)
    }
  }
}
</script>

<style></style>
